import { GET_APPROVAL_OVERTIME } from "@/store/modules/mutation-types";

export default {
  actions: {
    async [GET_APPROVAL_OVERTIME]({ dispatch }, params) {
      console.log("GET_APPROVAL_OVERTIME");
      const res = await dispatch("apiGet", {
        url: "/kanri/approval_overtimes",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  }
};
